import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs/Observable';

import { ConfirmResult } from './shared/confirm.model'

@Component({
    moduleId: module.id,
    selector: 'confirmDlg',
    templateUrl: 'confirm.html',
})
export class ConfirmComponent implements OnChanges {
    @Input() inputAction: string = "delete";    // any action you want catch when observing @Output() outputExecuteCommand
    @Input() confirmDlgAppliesTo: string = "";  // what object the delete, leave etc applies tom f ex Package Intruction
    @Input() inputBtnType: string = "warning";  // bootstrap class suffix default, danger, warning, primary, info, link, success
    @Input() dialogText: string = "";  // optional text
    @Input() inputForId: number = -1;    // store the id that delete/ remove/save etc that the action applies to
    @Input() inputForInstructionType: number = -1;    // store the type that delete/ remove/save etc that the action applies to
    @Output() outputExecuteCommand: EventEmitter<ConfirmResult> = new EventEmitter<ConfirmResult>();

    action: ConfirmResult = new ConfirmResult();
    btnType: string;
    confirmText: string;
    commandButtonText: string = "Delete";
    cancelButtonText: string = "Cancel";
    executeBtnDisabled: boolean = false;
    commandButtonTitleText: string;
    cancelButtonTitleText: string = "Cancels the operation and closes this dialog";
    dlgAppliesTo: string = "";
    headerText: string;

    modalDlg: NgbModalRef;

    constructor(private modalService: NgbModal) { }

    ngOnInit(): void {
        this.action.Action = this.inputAction;
        this.action.Id = this.inputForId;
        this.action.InstructionType = this.inputForInstructionType;
        this.dlgAppliesTo = this.confirmDlgAppliesTo;
        this.btnType = this.inputBtnType;
        this.setDlgType();
    }

    ngOnChanges(): void {
        this.action.Action = this.inputAction;
        this.action.Id = this.inputForId;
        this.dlgAppliesTo = this.confirmDlgAppliesTo;
        this.btnType = this.inputBtnType;
        this.setDlgType();
    }

    setDlgType(): void {

        if (this.action.Action == "delete" || this.action.Action == "deletesenttomulti")
            this.setAsDeleteDlg();
        else if (this.action.Action == "deleteall" || this.action.Action == "deleteallsenttomulti")
            this.setAsDeleteAllDlg();
        else if (this.action.Action == "makepreliminary" || this.action.Action == "makepreliminarysenttomulti")
            this.setAsMakePreliminaryDlg();
        else if (this.action.Action == "makepreliminaryall" || this.action.Action == "makepreliminaryallsenttomulti")
            this.setAsMakePreliminaryAllDlg();
        else if (this.action.Action == "activate")
            this.setAsActivateDlg();
        else if (this.action.Action == "continuewithoutsave")
            this.setAsConfirmNotSavedDlg();
        else if (this.action.Action == "savefail")
            this.setAsSaveFailDlg();
        else if (this.action.Action == "deletepart"||this.action.Action=="deletesupplier")
            this.setAsDeleteDlg();
        else if (this.action.Action == "deletemateriallevel")
            this.setAsConfirmDeleteLevelDlg();
        else if (this.action.Action == "deletematerialcode")
            this.setAsDeleteDlg();
        else if (this.action.Action == "leave")
            this.setAsConfirmLeaveDlg();
        else if (this.action.Action == "deletematerial")
            this.setAsDeleteDlg();
        else if (this.action.Action == "info")
            this.setAsInfoDlg();
        else if (this.action.Action == "continuewithoutsaveDuplicatePkgCode")
            this.setAsConfirmNotSavedDlg();
        else if (this.action.Action == "continuewithoutsaveNewPkgCode")
            this.setAsConfirmNotSavedDlg();
        else if(this.action.Action=="searchfail")
            this.setAsSearchFailDlg();
        // TODO Add more confirms as needed
    }

    execute() {
        this.action.Action = this.inputAction;
        this.action.Id = this.inputForId;
        this.outputExecuteCommand.emit(this.action);
    }

    showCommandButton(): boolean {
        return this.commandButtonText.length > 0;
    }

    openAlertDlg(): void {
        // TODO 
    }

    setAsDeleteDlg(): void {
        this.btnType = "danger";
        this.headerText = "Delete " + this.dlgAppliesTo + "?";
        this.confirmText = "Are you sure you want to delete this " + this.dlgAppliesTo + "?";
        this.commandButtonTitleText = "Deletes the " + this.dlgAppliesTo + ", this action cant be undone"
    }

    setAsDeleteAllDlg(): void {
        this.btnType = "danger";
        this.headerText = "Delete all " + this.dlgAppliesTo + "?";
        this.confirmText = "Are you sure you want to delete all checked items?";
        this.commandButtonTitleText = "Deletes all action cant be undone";
    }

    setAsMakePreliminaryDlg(): void {
        this.btnType = "warning";
        this.headerText = "Revert to status preliminary " + this.dlgAppliesTo + "?";
        this.commandButtonText = "Make preliminary";
        this.confirmText = "Are you sure you want to revert this " + this.dlgAppliesTo + " to preliminary?";
        this.commandButtonTitleText = "Revert to preliminary cant be undone."
    }

    setAsMakePreliminaryAllDlg(): void {
        this.btnType = "warning";
        this.headerText = "Revert all to status preliminary?";
        this.commandButtonText = "Make all preliminary";
        this.confirmText = "Are you sure you want to revert all checked items to preliminary?";
        this.commandButtonTitleText = "Revert to preliminary cant be undone."
    }

    setAsActivateDlg(): void {
        this.btnType = "success";
        this.headerText = "Activate " + this.dlgAppliesTo + "?";
        this.commandButtonText = "Activate";
        this.confirmText = "Are you sure you want to activate this " + this.dlgAppliesTo + "?"
        this.commandButtonTitleText = "Activate the " + this.dlgAppliesTo + ", this action cant be undone"
    }

    setAsConfirmLeaveDlg(): void {
        this.headerText = "The " + this.dlgAppliesTo + " is not saved?";
        this.confirmText = "The " + this.dlgAppliesTo + " is not saved.\nAre you sure you want to leave saving?";
        this.commandButtonText = "Leave page";
        this.cancelButtonText = "Stay on page";
        this.commandButtonTitleText = "Leaves this page without saving, this action cant be undone"
    }

    setAsConfirmNotSavedDlg(): void {
        this.btnType = "success";
        this.headerText = "The " + this.dlgAppliesTo + " is not saved?";
        this.confirmText = "The current " + this.dlgAppliesTo + " is not saved. \nDo you want to continue without saving?"
        this.commandButtonText = "Ok";
        this.cancelButtonText = "Cancel";
        this.commandButtonTitleText = "Continue without saving"
    }

    setAsConfirmDeleteLevelDlg(): void {
        this.btnType = "danger";
        this.headerText = "Delete " + this.dlgAppliesTo + "?";
        this.confirmText = "This " + this.dlgAppliesTo + " and all its sub levels will be deleted. \nAre you sure you want to continue?";
        this.commandButtonTitleText = "Deletes the " + this.dlgAppliesTo + ", this action cant be undone"
    }

    setAsSaveFailDlg(): void {
        this.commandButtonText = "";
        this.cancelButtonText = "Close";
        this.headerText = "Save " + this.dlgAppliesTo;
        this.confirmText = this.dialogText;
    }
    setAsSearchFailDlg():void{
        this.commandButtonText = "";
        this.cancelButtonText = "Close";
        this.headerText = "Find " + this.dlgAppliesTo;
        this.confirmText = this.dialogText;
    }
    setAsInfoDlg(): void {
        this.commandButtonText = "";
        this.btnType = "info";
        this.cancelButtonText = "Close";
        this.headerText = "Info " + this.dlgAppliesTo;
        this.confirmText = this.dialogText;
    }

    cancel() {
        this.action.Action = 'cancel';
        this.action.Id = -1;
        this.outputExecuteCommand.emit(this.action);
    }
}



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/dialogboxes/confirm.component.ts